import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { usePersonalDetails } from '../../hooks/use-personal-details.js';
import { LoadingData } from '../LoadingData.js';

const PersonalGreeting = ()=>{
    const { personalDetailsData , isFetching  } = usePersonalDetails();
    const intl = useIntl();
    if (isFetching) {
        return /*#__PURE__*/ React__default.createElement(LoadingData, null);
    }
    const showPersonalizedLabel = intl.hasLabel('account.profile.title.personalized') && (personalDetailsData.firstName || personalDetailsData.lastName);
    const message = showPersonalizedLabel ? intl.getFormattedLabel('account.profile.title.personalized', {
        hideLabelKey: true,
        labelData: swcHelpers.objectSpread({}, personalDetailsData, personalDetailsData.firstName ? {
            firstLetter: personalDetailsData.firstName.substring(0, 1)
        } : {})
    }) : intl.getLabel('account.profile.title');
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, message);
};
var PersonalGreeting$1 = PersonalGreeting;

export { PersonalGreeting$1 as default };
//# sourceMappingURL=PersonalGreeting.js.map
